export const writeToStorage = (key: string, value: any) => {
  localStorage.setItem(key, JSON.stringify(value));
  return key;
};

export const readFromStorage = (key: string, fallback: any = []) => {
  const item = localStorage.getItem(key);
  return item ? JSON.parse(item) : fallback;
};
